import api from './api';
import store from './store';

import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(input: string | number): string {
  const date = new Date(input)
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  })
}

export function absoluteUrl(path: string) {
  return `${process.env.NEXT_PUBLIC_APP_URL}${path}`
}


export function getCookie(cookiename) {
  // Get name followed by anything except a semicolon
  var cookiestring = RegExp(cookiename + "=[^;]+").exec(document.cookie);
  // Return everything after the equal sign, or an empty string if the cookie name not found
  return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");
}


export function parseErrorMessage(jsonResponse, usePipe=false) {
  if (Object.keys(jsonResponse).length === 1) {
    if (jsonResponse['detail']) {
      return jsonResponse['detail'];
    } else {
      const val = jsonResponse[Object.keys(jsonResponse)[0]];
      if (Array.isArray(val) && !usePipe) {
        return val.join(" ");
      } else if (Array.isArray(val)) {
        return val.join("|");
      }
      return val;
    }
  }
  // TODO: need to complete this function
  return "More than 1 error";
}

export function unauthRes(res) {
  if (res.status === 401 && res.statusText === 'Unauthorized') {
    // Return error instead of throwing
    return new Error('The security token in your request has expired. Please refresh');
  }
  return null;
}

export async function hashString(str) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data); // Using SHA-256 instead of MD5 for better security
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // Convert buffer to byte array
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // Convert bytes to hex string
  return hashHex;
}

export function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export async function verifyToken() {
  let attempts = 0;
  const maxAttempts = 5;

  while (attempts < maxAttempts) {
    try {
      // Get the latest access token from the store before verification
      const accessToken = store.getItem('accessToken');
      const isValid = await api.verifyToken(accessToken);
      if (isValid) {
        return; // Exit the function if the token is valid
      } else {
        const newAccessToken = await api.refreshToken(store.getItem('refreshToken'));
        attempts++;
      }
    } catch (e) {
      store.clear();
      throw new Error('Something went wrong. Please refresh and sign in again.');
    }
  }

  // If we reach here, it means all attempts failed
  throw new Error('Unable to refresh token after multiple attempts. Please sign in again.');
}

export function getPlanProductId(planName) {
    switch(planName) {
        case 'Starter': return 649292;      // Starter plan product ID
        case 'Standard': return 649293;     // Standard plan product ID
        case 'Professional': return 654238; // Professional plan product ID
        case 'Enterprise': return 654239;   // Enterprise plan product ID
        case 'Enterprise Plus': return 912601; // Enterprise Plus plan product ID
        case 'Enterprise Scale': return 912602; // Enterprise Scale plan product ID
        default: return null;
    }
}

export function getPlanPrice(planName) {
    switch(planName) {
        case 'Starter': return process.env.REACT_APP_STARTER_PRICE;
        case 'Standard': return process.env.REACT_APP_STANDARD_PRICE;
        case 'Professional': return process.env.REACT_APP_PROFESSIONAL_PRICE;
        case 'Enterprise': return process.env.REACT_APP_ENTERPRISE_PRICE;
        case 'Enterprise Plus': return process.env.REACT_APP_ENTERPRISE_PLUS_PRICE;
        case 'Enterprise Scale': return process.env.REACT_APP_ENTERPRISE_SCALE_PRICE;
        default: return null;
    }
}

export function getPlanCredits(planName) {
    switch(planName) {
        case 'Starter': return '100,000';
        case 'Standard': return '300,000';
        case 'Professional': return '750,000';
        case 'Enterprise': return '2,000,000';
        case 'Enterprise Plus': return '6,000,000';
        case 'Enterprise Scale': return '10,000,000';
        default: return '0';
    }
}
